// Placing one visit of a repeat by hand (7 Oct 2026): "Change time" on
// Check the dates puts the visit on the diary as a block the stylist drags
// (or taps) to a new time, seeing the clashes as they go, then "Use 11:30"
// hands the time back to the panel. One placement at a time.
//   target: { date, staffId, minutes, duration, label }
import { useEffect, useState } from 'react'

let target = null
let handlers = null
const listeners = new Set()
const emit = () => listeners.forEach(fn => fn(target))

export const getPlacement = () => target

export const startPlacement = (t, { onDone, onCancel } = {}) => {
  target = { ...t }
  handlers = { onDone, onCancel }
  emit()
}

export const movePlacement = (minutes) => {
  if (!target) return
  target = { ...target, minutes }
  emit()
}

// Their choice: the time goes back to the panel; `next` goes straight on
// to the next clash instead of back to the list
export const finishPlacement = ({ next = false } = {}) => {
  const t = target
  const h = handlers
  target = null
  handlers = null
  emit()
  if (t && h && h.onDone) h.onDone(t.minutes, t, { next })
}

// Put away (Cancel, or the panel opened again from its pill)
export const cancelPlacement = ({ quiet = false } = {}) => {
  if (!target) return
  const h = handlers
  target = null
  handlers = null
  emit()
  if (!quiet && h && h.onCancel) h.onCancel()
}

export const usePlacement = () => {
  const [value, setValue] = useState(target)
  useEffect(() => {
    listeners.add(setValue)
    setValue(target)
    return () => { listeners.delete(setValue) }
  }, [])
  return value
}

// Whether the day diary is on screen to place on (otherwise the panel
// falls back to a time picker)
let columns = 0
export const columnMounted = () => { columns += 1; return () => { columns -= 1 } }
export const diaryIsOpen = () => columns > 0

// The visit's time against the column's other bookings
export const clashesAt = (minutes, duration, events) => (events || []).filter(e => minutes < e.endMinutes && minutes + duration > e.startMinutes)

// While a repeat's dates are being checked, a tap on the diary must never
// re-point the booking (that moves every visit of the repeat)
let checking = false
export const setCheckingDates = (on) => { checking = !!on }
export const isCheckingDates = () => checking
